// extracted by mini-css-extract-plugin
export default {"fqa-style":"Faq_fqa-style__T8j3C","menu":"Faq_menu__jb7AH"};